export default "__VITE_ASSET__44f0dad9__"